import Service, { service } from '@ember/service';
import { task, all } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';

import { query as emberDataQuery } from '@ember-data/legacy-compat/builders';

class HostedFileRepo extends Service {
  @service store;

  hostedFiles = this.store.peekAll('hosted-file');

  queryHostedFiles = task({ enqueue: true }, waitFor(async query => {
    query.searchTerm ??= null;
    query.folder ??= 'noFolder';

    const { searchTerm, pageNumber } = query;

    const {
      content: files,
    } = await this.store.request(emberDataQuery('hosted-file', query, { reload: true }));

    return {
      searchTerm,
      pageNumber,
      files: [...files],
      count: files?.meta?.count ?? 0,
    };
  }));

  saveHostedFiles = task(waitFor(async hostedFiles => {
    await all(hostedFiles.map(hostedFile => hostedFile.save()));
  }));
}

export default HostedFileRepo;
